/**
 * Modelo para el usuario logueado o por loguear
 * Una clase User que posee los datos del logueo de usuario.
 * Tiene métodos para acortar el obtener información y así
 * reducir la verbosidad del código.
 *
 * Una instancia de la clase (singleton) es incluida en el Vuex
 * cuando se loguea.
 */

// import CurrentUserDTO, { Resource } from '@/api/auth/dto/CurrentUserDTO'
// import { userActions } from '@/utils/constant'

// import { lowerCaseAllWordsExceptFirstLetters, getUserData, getFullToken } from '../utils'

export class User {
  data: any;
  static instance: User | null = null;
  application: string;
  attributes: Record<string, any>;
  username: string;
  jti: string;
  fullname: string;
  lastLogin: string;
  accessToken: string;
  tokenType: string;
  refreshToken: string;
  expiresIn: string;
  profiles: string[];
  // resources: Resource[];

  // "scope": "UPT20001",
  // "application": "T2",
  // "attributes": {},
  // "username": "ADMIN001",
  // "jti": "fd41cfa1-9696-4939-b079-b595097df05f",
  // "fullname": "GENERICO ADMIN001",
  // "lastLogin": "2022-05-11T12:32:00",
  // "access_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJsYXN0TG9naW4iOiIyMDIyLTA1LTExVDEyOjMyOjAwIiwibG9nX2lkIjo5MDAwNzEsInVzZXJfbmFtZSI6IkFETUlOMDAxIiwiYXV0aGVudGljYXRpb25fdHlwZSI6ImxkYXAiLCJjbGllbnRfaWQiOiJhbm9ueW1vdXMiLCJhcHBsaWNhdGlvbiI6IlQyIiwic2NvcGUiOlsiVVBUMjAwMDEiXSwiZXhwaXJlX2F0IjoxNjUyMjcwNzUxLCJhdHRyaWJ1dGVzIjp7fSwiZnVsbG5hbWUiOiJHRU5FUklDTyBBRE1JTjAwMSIsImV4cCI6MTY1MjI3MDc1MSwiZXhwaXJlc19pbiI6NTQwMCwianRpIjoiZmQ0MWNmYTEtOTY5Ni00OTM5LWIwNzktYjU5NTA5N2RmMDVmIiwidXNlcm5hbWUiOiJBRE1JTjAwMSJ9.LYi0dN6DYtZ5Nq0122nuz3TkpONXCcgjJ4AoQN_MPzPQg4klFzkGd4KEdK5HfsHZjM3hG6W-8ZJM--aatN-t4W6EIh_eO0C8rW0OMIUl_b-CLjbVJkO0C8GB3yrFR3IOjMp9SoH4abvoHMieC7aDsdGDxRUACOBV-oOzqWBc4CY",
  // "token_type": "bearer",
  // "refresh_token": "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJsYXN0TG9naW4iOiIyMDIyLTA1LTExVDEyOjMyOjAwIiwibG9nX2lkIjo5MDAwNzEsInVzZXJfbmFtZSI6IkFETUlOMDAxIiwiYXV0aGVudGljYXRpb25fdHlwZSI6ImxkYXAiLCJjbGllbnRfaWQiOiJhbm9ueW1vdXMiLCJhcHBsaWNhdGlvbiI6IlQyIiwic2NvcGUiOlsiVVBUMjAwMDEiXSwiYXRpIjoiZmQ0MWNmYTEtOTY5Ni00OTM5LWIwNzktYjU5NTA5N2RmMDVmIiwiZXhwaXJlX2F0IjoxNjUyMjcwNzUxLCJhdHRyaWJ1dGVzIjp7fSwiZnVsbG5hbWUiOiJHRU5FUklDTyBBRE1JTjAwMSIsImV4cCI6MTY1MjM1MTc1MSwiZXhwaXJlc19pbiI6NTQwMCwianRpIjoiYTBkMTc5YTYtMThhMS00MGEzLTlhODEtMDk2ODZiZjRiMjI1IiwidXNlcm5hbWUiOiJBRE1JTjAwMSJ9.OVBdnwudWNgpKR1wSb_X5JRZbMP9fOtM8F620weBqU_J4F7dF8x-ues3IxL7gnbd0TMJpIWg3J88ebj2rYXPbm3MhxNkHQprql0ZaYzn5rRik7oEXtxv8TifX-dQ-d5CzEvpsdjDw0SRlFPBM06W8pz5fBXLt1iR-HU_IOGdbbs",
  // "expires_in": 5400

  /**
    * @param {Object} [data] datos del usuario logueado (optional)
    */
  constructor (data?: any) {
    // usamos un patrón singleton
    // si ya hay una instancia del usuario,
    // establecer posible nuevos datos
    // y devolverla
    if (User.instance) {
      // User.instance.setData(data)
      // return User.instance
    }
    // en caso de no existir, establecemos
    // posibles datos, guardamos la instancia
    // y la devolvemos
    this.setData(data)
    User.instance = this
    return this
  }

  /**
    * establecer datos del usuario en la
    * propiedad `data` de la clase
    * @param [data] objeto del usuario (usualmente, la respuesta de la llamada de loguear usuario)
    */
  setData (data?: any | null) {
    this.data = data

    this.profiles = data?.profiles || ['']
    this.username = data?.username || ''
  }

  saveData () {
    window.localStorage.setItem('UserData', JSON.stringify(this.data))
  }

  removeData () {
    this.setData(null)
    this.removeDataFromStorage()
  }

  removeDataFromStorage () {
    window.localStorage.removeItem('UserData')
  }

  getProfile () {
    return (this.data?.profiles?.[0])
  }

  getProfiles () {
    return (this.data?.profiles)
  }

  getUsername () {
    return (this.data?.username)
  }

  getRol () {
    if (this.data?.profiles?.[0] === 'UPOD0001') return 'ADMINISTRADOR'
    else if (this.data?.profiles?.[0] === 'UPOD0002') return 'OPEX'
    else if (this.data?.profiles?.[0] === 'UPOD0003') return 'CAPEX'
    else if (this.data?.profiles?.[0] === 'UPOD0004') return 'CONTROL_GESTION'
  }

  // validAction (action) {
  //   let isValid = false
  //   if (this.data?.profiles) {
  //     this.data.profiles.forEach(profile => {
  //       const actions = userActions[profile]
  //       if (actions && actions.indexOf(action) > -1) {
  //         isValid = true
  //       }
  //     })
  //   }
  //   return isValid
  // }

  // getActions () {
  //   let actions = []
  //   if (this.data?.profiles) {
  //     this.data.profiles.forEach(profile => {
  //       actions = actions.concat(userActions[profile])
  //     })
  //   }
  //   return actions.filter((value, index, array) => array.indexOf(value) === index)
  // }

  isLogin () {
    return !!window.localStorage.getItem('UserData')
  }
}

export default User
